/**
 * Devuelve las traducciones.
 *
 * NOTA: Los ficheros de traducciones son gordos,
 * los guardamos en localstorage.
 * Devolvemos en seguida la versión guardada si existe,
 * y luego, checkeamos para actualizar si hace falta.
 *
 * @param {string} locale la locale en 2 o mas caracteres.
 * @returns {Object<key, value>} el objeto de traducciones
 */
export async function getTranslations(locale) {
  /**
   * intentamos recuperar del localstorage
   */
  let translation = await getTranslationFromLocalStorage(locale);

  if (!translation?.data) {
    /**
     * si no existen en localstorage,
     * estamos obligado a pedir al servidor:
     */
    translation = await getTranslationFromServer(locale);
    saveTranslationToLocal(locale, translation);
  } else {
    /**
     * registramos un callback,
     * que se ejecutara luego,
     * para actualizar la traducciones (si cambiaron)
     */
    setTimeout(() => {
      requestIdleCallback(async () => {
        const newHash = await getHashFromServer(locale);

        if (newHash !== translation?.hash) {
          /**
           * el fichero ha cambiado, lo cargamos para el siguiente inicio
           * de session del usuario
           */
          translation = await getTranslationFromServer(locale);
          saveTranslationToLocal(locale, translation);
        }
      });
    }, 5000);
  }

  /**
   * devolvemos el objeto de traduciones
   */
  return translation?.data;
}

async function getHashFromServer(locale) {
  const langProperties = convertLocaleToServerLang(locale);
  const response = await fetch(`/translations/${langProperties}/hash`);
  return response.json();
}

async function getTranslationFromServer(locale) {
  const langProperties = convertLocaleToServerLang(locale);
  const response = await fetch(`/translations/${langProperties}`);
  return response.json();
}

function getTranslationFromLocalStorage(locale) {
  let translation;

  try {
    const content = localStorage.getItem(`translations.${locale}`);
    const hash = localStorage.getItem(`translations.code.${locale}`);

    if (content && hash) {
      translation = { hash, data: JSON.parse(content) };
    }
  } catch (e) {
    console.error(e);
  }

  return translation;
}

function saveTranslationToLocal(locale, translation = {}) {
  const { hash, data } = translation;
  try {
    localStorage.setItem(`translations.code.${locale}`, hash);
    localStorage.setItem(`translations.${locale}`, JSON.stringify(data));
  } catch (e) {
    console.error(e);
  }
}

/**
 * Devuelve el codigo `lang` que se usa en el servidor para los ficheros "lang_es.properties"
 * Este metodo es especial para Ediwin, para convertir el 'pt-BR' en "lang_br.properties"
 * @param {string} locale la locale
 * @returns {string}
 */
function convertLocaleToServerLang(locale = '') {
  if (locale === 'pt-BR') {
    return 'br';
  }
  return locale.substring(0, 2);
}
